import { fork } from 'redux-saga/effects';

import { createInfluencerSaga } from './sagas/createInfluencer';
import { deleteInfluencerSaga } from './sagas/deleteInfluencer';
import { fetchInfluencersSaga } from './sagas/fetchInfluencers';

export const influencersSaga = function* () {
  yield fork(createInfluencerSaga);
  yield fork(deleteInfluencerSaga);
  yield fork(fetchInfluencersSaga);
};
